import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';

const DiscardChangesModal = forwardRef(function DiscardChangesModal(
    { onContinueEditing, onDiscardAndLeave },
    ref
) {
    const modalRef = useRef();
    const discardActionRef = useRef(null);
    const pendingSegmentIndexRef = useRef(null);

    useImperativeHandle(ref, () => ({
        open(action, segmentIndex = null) {
            discardActionRef.current = action;
            pendingSegmentIndexRef.current = segmentIndex;
            modalRef.current.setAttribute('open', '');
            modalRef.current.removeAttribute('overlayshouldclosemodal');
        }
    }));

    useEffect(() => {
        const modal = modalRef.current;
        if (!modal) return;
        const handleModalClosed = () => {
            discardActionRef.current = null;
            pendingSegmentIndexRef.current = null;
        };
        modal.addEventListener('modal-closed', handleModalClosed);
        return () => modal.removeEventListener('modal-closed', handleModalClosed);
    }, []);

    const handleContinueEditing = () => {
        discardActionRef.current = null;
        pendingSegmentIndexRef.current = null;
        modalRef.current.removeAttribute('open');
        onContinueEditing?.();
    };

    const handleDiscardAndLeave = () => {
        const action = discardActionRef.current;
        const segmentIndex = pendingSegmentIndexRef.current;
        discardActionRef.current = null;
        pendingSegmentIndexRef.current = null;
        modalRef.current.removeAttribute('open');
        onDiscardAndLeave?.(action, segmentIndex);
    };

    return (
        <gds-modal type="modal" ref={modalRef}>
            <span slot="header">Discard unsaved changes?</span>
            <p>Changes to this page haven't been saved. Leaving now will remove them.</p>
            <gds-button appearance="secondary" size="large" slot="buttons" type="button" onClick={handleContinueEditing}>
                Continue Editing
            </gds-button>
            <gds-button appearance="primary" size="large" slot="buttons" type="button" onClick={handleDiscardAndLeave}>
                Discard and Leave
            </gds-button>
        </gds-modal>
    );
});

export default DiscardChangesModal;
